export default __webpack_public_path__ + "static/media/silhouette-guy4.33d94536.svg";